import CheckSvg from "$assets/icons/check.svg?icon";
import type { ComponentProps } from "react";

// Raw svg lives in assets; this wrapper only preserves the long-standing default
// of rendering in the primary colour. Callers can still override `color`.
const CheckIcon = (props: ComponentProps<typeof CheckSvg>) => (
  <CheckSvg color="primary" {...props} />
);

export default CheckIcon;
